import React from 'react'
import { useNav } from '../hooks/useNav'
import { useUrlSearchParams } from '../hooks/useUrlSearchParams'
// import { BomPageContainer } from '../components/BomPageContainer'
import BomGoogleMap from '../components/BomGoogleMap.js'
import NavButtonRow from '../components/NavButtonRow.js'
import { Container, Paper, Stack } from '@mui/material'
// import Grid2 from '@mui/material/Unstable_Grid2' // Grid version 2
import PageFooter from '../components/PageFooter.js'
import TitleRow from '../components/TitleRow.js'
import GglRow from '../components/GglRow.js'
import appUtilities from '../utilities/appUtilities.js'

function getFencePosts(map_posts) {
    let sessionObjPostObjects = []
    const postsString = map_posts
    if (postsString) {
        sessionObjPostObjects = JSON.parse(postsString)
    }
    return sessionObjPostObjects
}

function getSessionObj_ArrayOfPosts_Obj(map_posts) {
    let arrayOfObj = []
    let postsString = map_posts // loaded by default
    if (postsString) {
        arrayOfObj = JSON.parse(postsString)
    }
    return arrayOfObj
}

function writePostObj(str, handleInputChange) {
    const fakeEvent = {
        target: {
            value: str,
        },
    }
    const paramKey = 'map_posts'
    handleInputChange(fakeEvent, { paramKey })
}

function writeZoom(zoom, handleInputChange) {
    const str = zoom.toString()
    const fakeEvent = {
        target: {
            value: str,
        },
    }
    const paramKey = 'zoom'
    handleInputChange(fakeEvent, { paramKey })
}

function writeMapCenter(center, handleInputChange) {
    const str = JSON.stringify(center)
    const fakeEvent = {
        target: {
            value: str,
        },
    }
    const paramKey = 'center'
    handleInputChange(fakeEvent, { paramKey })
    // console.log(`just sent off ${str} to write to session`)
}

export default function GglMap() {
    //  ****************************
    //                      useState
    //  ****************************

    const [handleInputChange, handleValue, sessionObj, setDefault] =
        useUrlSearchParams()
    const [pgID, pgNav] = useNav(sessionObj)

    const [newPost, setNewPost] = React.useState('')
    const [deletePost, setDeletePost] = React.useState(false)
    const [clearAllPosts, setClearAllPosts] = React.useState(false)
    const [repositionedFencePost, setRepositionedFencePost] = React.useState({})
    const [zoomState, setZoomState] = React.useState(() => {
        let val =
            sessionObj && 'zoom' in sessionObj
                ? parseInt(sessionObj.zoom, 10)
                : 4
        return val
    })
    //  on mount - it loads either sessionObj or default then Ggl Map handles center.
    const [centerState] = React.useState(() => {
        let val =
            sessionObj && 'center' in sessionObj
                ? JSON.parse(sessionObj.center)
                : { lat: 39.7044195119823, lng: -94.59582695831378 }

        return val
    })

    // lodashCenterState controlled by debounce update on map center chg
    //  a useEffect on dismount reports this sessionObj
    const [lodashCenterState, setLodashCenterState] = React.useState(() => {
        let val =
            sessionObj && 'center' in sessionObj
                ? JSON.parse(sessionObj.center)
                : { lat: 39.7044195119823, lng: -94.59582695831378 } //  geographic center of contiguous USA

        return val
    })

    //  ****************************
    //                      useRef
    //  ****************************

    // const idRef = React.useRef('' + (Date.now() % 1000) + `-ggl`)

    // console.log(
    //     `%c ${idRef.current} in context`,
    //     'background: yellow; color: red'
    // )

    //  ****************************
    //                      useInRenderFunction
    //  ****************************

    // @ts-ignore
    const fencePosts = getFencePosts(sessionObj.map_posts)
    const perimeterMeters = appUtilities.perimeterCalc(fencePosts) // units google wishes to calc with
    const acre = appUtilities.areaCalc(fencePosts)
    // @ts-ignore
    let unitPreferred = sessionObj.unit
    const unitPreferredCapitalized = appUtilities.capitalize(unitPreferred)
    const perimeterInPreferredUnits = appUtilities.getSizeInUnitPreferred(
        unitPreferred,
        perimeterMeters
    )
    const fenceLengthLimit = 75000
    //  ****************************
    //                      useEffect
    //  ****************************

    //  *****************   size   *****************

    // problem - if i change zooom preferred size xhanges bec. handleInpput chgs ev. time we save to useURLSearchParams
    React.useEffect(() => {
        const theSize = perimeterInPreferredUnits.toString().replaceAll(',', '')
        const fakeEvent = {
            target: {
                value: theSize,
            },
        }
        const paramKey = 'size'
        // console.log(`*${idRef.current} in size useEffect`)
        // @ts-ignore
        handleInputChange(fakeEvent, { paramKey })
    }, [perimeterInPreferredUnits, handleInputChange])

    //  *****************   add a post   *****************

    React.useEffect(() => {
        if (newPost !== '') {
            // @ts-ignore
            let sessionObj_ArrayOfPosts_Obj = getSessionObj_ArrayOfPosts_Obj(
                // @ts-ignore

                sessionObj.map_posts
            )
            let newPostObj = [
                ...sessionObj_ArrayOfPosts_Obj,
                JSON.parse(newPost),
            ] // like to keep this out of string concatenation

            writePostObj(JSON.stringify(newPostObj), handleInputChange)
            // console.log(`${idRef.current} in map_post useEffect`)
            setNewPost('')
            // console.log(`*${idRef.current} in newPost useEffect`)
        }
        // @ts-ignore
    }, [newPost, sessionObj.map_posts, handleInputChange])

    //  *****************   delete a post   *****************

    React.useEffect(() => {
        if (deletePost) {
            // @ts-ignore
            let sessionObj_ArrayOfPosts_Obj = getSessionObj_ArrayOfPosts_Obj(
                // @ts-ignore

                sessionObj.map_posts
            )
            if (sessionObj_ArrayOfPosts_Obj.length > 1) {
                let newPostObj = sessionObj_ArrayOfPosts_Obj.slice(0, -1)
                writePostObj(JSON.stringify(newPostObj), handleInputChange)
            } else {
                writePostObj('[]', handleInputChange) //  cleaner looking URL when removing the last map_post
            }
            // console.log(`*${idRef.current} in delete post useEffect`)

            setDeletePost(false)
        }
        // @ts-ignore
    }, [deletePost, sessionObj.map_posts, handleInputChange])

    //  *****************   clear all posts   *****************

    React.useEffect(() => {
        if (clearAllPosts) {
            let noPostObj = [] // like to keep this out of string concatenation
            writePostObj(JSON.stringify(noPostObj), handleInputChange)
            setClearAllPosts(false)
        }

        // console.log(`*${idRef.current} in clear all posts useEffect`)
    }, [clearAllPosts, handleInputChange])

    //  *****************  save zoom   *****************

    React.useEffect(() => {
        writeZoom(zoomState, handleInputChange)
        // console.log(`*${idRef.current} in zoom useEffect`)
    }, [zoomState, handleInputChange])

    //  *****************   reposition post   *****************

    React.useEffect(() => {
        // @ts-ignore

        if (repositionedFencePost.thePost) {
            let sessionObjPostObjects = []
            // @ts-ignore
            let postsString = sessionObj.map_posts // loaded by default
            if (postsString !== '[]') {
                sessionObjPostObjects = JSON.parse(postsString)
            } else {
                throw new Error(
                    'repositioned map_post when there are no map_posts'
                )
            }
            // @ts-ignore

            sessionObjPostObjects[repositionedFencePost.idx] = JSON.parse(
                // @ts-ignore
                repositionedFencePost.thePost
            )

            let newPostObj = JSON.stringify(sessionObjPostObjects)

            writePostObj(newPostObj, handleInputChange)
            // console.log(`*${idRef.current} in reposition useEffect`)
            setRepositionedFencePost({})
        }
    }, [
        // @ts-ignore
        repositionedFencePost.thePost,
        // @ts-ignore
        repositionedFencePost.idx,
        // @ts-ignore
        sessionObj.map_posts,
        handleInputChange,
    ])

    //  *****************   preserve map center   *****************

    // for the unmounting
    React.useEffect(() => {
        const lat = lodashCenterState.lat
        const lng = lodashCenterState.lng
        const center = { lat, lng }
        writeMapCenter(center, handleInputChange)
        // console.log(`*${idRef.current} in lodash Center useEffect`)
    }, [lodashCenterState.lat, lodashCenterState.lng, handleInputChange])

    //  *****************   establish default params   *****************

    React.useEffect(() => {
        // @ts-ignore
        setDefault(pgID)
        // console.log(`*${idRef.current} in setDefault useEffect`)
    }, [pgID, setDefault])

    //  ****************************
    //                      useCallback
    //  ****************************

    const addFencePost = React.useCallback((event) => {
        const map_post = {
            lat: event.latLng.lat(),
            lng: event.latLng.lng(),
        }

        setNewPost(JSON.stringify(map_post))
    }, [])

    const clearAll = React.useCallback(() => {
        setClearAllPosts(true)
    }, [])

    const deleteLast = React.useCallback(() => {
        setDeletePost(true)
    }, [])

    const re_positionFencePost = React.useCallback((event, selectedIdx) => {
        const newPosition = {
            lat: event.latLng.lat(),
            lng: event.latLng.lng(),
        }
        const postString = JSON.stringify(newPosition)
        const repositionedFencePost = {
            thePost: postString,
            idx: selectedIdx,
        }

        setRepositionedFencePost(repositionedFencePost)
    }, [])

    const writeCenterRef = React.useCallback(
        (value) => {
            setLodashCenterState(value)
            // console.log(`center value is ${value}`)
        },
        [setLodashCenterState]
    )

    const validLength = perimeterMeters < fenceLengthLimit
    const validFence = perimeterMeters > 0 && validLength

    //  ****************************
    //                      RETURN
    //  ****************************
    function handlePgNav(direction) {
        // @ts-ignore
        pgNav(direction)
    }

    return (
        <Container
            maxWidth="md"
            sx={{
                marginTop: 6,
            }}
        >
            <Paper elevation={8}>
                <Stack>
                    <TitleRow
                        handlePgNav={handlePgNav}
                        titleText={'Define a Perimeter'}
                    />
                    <GglRow
                        handleInputChange={handleInputChange}
                        handleValue={handleValue}
                        unitPreferred={unitPreferredCapitalized}
                        perimeterInPreferredUnits={perimeterInPreferredUnits}
                        acre={acre}
                        validLength={validLength}
                    />
                    {
                        <BomGoogleMap
                            fencePosts={fencePosts}
                            // setFencePosts={setFencePosts}
                            clearAll={clearAll}
                            addFencePost={addFencePost}
                            re_positionFencePost={re_positionFencePost}
                            setZoomState={setZoomState}
                            zoom={zoomState}
                            writeCenterRef={writeCenterRef}
                            center={centerState}
                        />
                    }
                    <NavButtonRow
                        handlePgNav={handlePgNav}
                        clearAll={clearAll}
                        deleteLast={deleteLast}
                        validFence={validFence}
                        postOnMap={fencePosts.length > 0 ? true : false}
                    />
                </Stack>{' '}
            </Paper>
            <PageFooter />
        </Container>
    )
}
